import {defineStore} from "pinia";
import {computed, ref} from "vue";

export const useHeaderLockPositionStore = defineStore('headerLockPosition', () => {
    const locked = ref<boolean>(false)
    const height = ref<number>(0)
    const lockedData = computed(() => locked);
    const heightData = computed(() => height);

    function setLock(lock: boolean){
        locked.value = lock;
    }

    function setHeight(heightf: number){
        height.value = heightf
    }

    return {lockedData, setLock, setHeight, heightData}
})
